import apiClient from './api';

function getAuthHeader(): Record<string, string> {
  const token = sessionStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface FigureMeta {
  id: string;
  project_id: string;
  storage_key: string;
  content_hash: string;
  mime_type: string;
  width: number;
  height: number;
  byte_size: number;
  caption: string | null;
  figure_label: string | null;
  created_at: string;
  created_by: string;
  last_modified_at: string;
}

export const figureService = {
  async upload(
    projectId: string,
    file: File,
    caption?: string,
    figureLabel?: string,
  ): Promise<FigureMeta> {
    const form = new FormData();
    form.append('file', file);
    if (caption) form.append('caption', caption);
    if (figureLabel) form.append('figure_label', figureLabel);
    try {
      const res = await apiClient.post<FigureMeta>(
        `/projects/${projectId}/figures/`,
        form,
        { headers: { ...getAuthHeader(), 'Content-Type': undefined } },
      );
      return res.data;
    } catch (err: unknown) {
      // Content-hash dedup: backend returns 409 with existing_figure_id.
      // Transparently reuse the existing figure rather than showing an error.
      const existingId: string | undefined = (err as { response?: { data?: { detail?: { existing_figure_id?: string } }; status?: number } })?.response?.data?.detail?.existing_figure_id;
      const errTyped = err as { response?: { status?: number } };
      if (errTyped?.response?.status === 409 && existingId) {
        const existing = await apiClient.get<FigureMeta>(
          `/projects/${projectId}/figures/${existingId}`,
          { headers: getAuthHeader() },
        );
        return existing.data;
      }
      throw err;
    }
  },

  async list(projectId: string): Promise<FigureMeta[]> {
    const res = await apiClient.get<FigureMeta[]>(`/projects/${projectId}/figures/`);
    return res.data;
  },

};
